import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ClampLines from 'react-clamp-lines';
import { Table, Glyphicon, Button } from 'react-bootstrap';
import actions from '../../../../constants/actions';

class LinksRowTable extends PureComponent {
  static propTypes = {
    links: PropTypes.array.isRequired,
  };
  
  static defaultProps = {
    links: [],
  };

  onPressAction = (id, label, hidden, action) => {
    this.props.showModalHandle(id, label, hidden, action);
  }

  render () {
    const {
      links,
    } = this.props;

    const arrowDirection = this.props.orderDirection !== '' 
      ? this.props.orderDirection ? 'arrow arrow-down' : 'arrow arrow-up'
      : '';

    return (
      <Table className="links-table">
        <thead>
          <tr>
            <th>Label</th>
            <th onClick={this.props.orderByClicks} style={{cursor: 'pointer'}}># Clicks <i className={arrowDirection}></i></th>
            <th>URL</th>
            <th>Tags</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            links.map((link, index) => (
              <tr key={`link-${index}`}>
                <td style={{ width: '200px', paddingRight: '5px' }}>
                  <p className="linkRowTwoLines">
                    <ClampLines
                      buttons={false}
                      lines="2"
                      text={link.label}
                    />
                  </p>
                </td>
                <td style={{ width: '100px', textAlign: 'center', paddingRight: '5px' }}>{link.clicks}</td>
                <td style={{ width: '269px', paddingRight: '7px' }}>
                  <p className="linkRowTwoLines" title={link.url}>
                    <ClampLines
                      buttons={false}
                      lines="2"
                      text={link.url}
                    />
                  </p>
                </td>
                <td style={{ width: '170px', paddingLeft: '7px' }}>
                  <p className="linkRowTwoLines">
                    {link.tags.map((tag, i) => (
                      <span className="link-label-content">{tag.label}</span>
                    ))}
                  </p>
                </td>
                <td style={{ width: '125px', paddingLeft: '5px' }}>
                  <Button
                    style={{ border: 'none' }}
                    onClick={() => this.onPressAction(link.id, link.label, link.hidden, actions.edit)}
                  >
                    <Glyphicon glyph="pencil" />
                  </Button>
                  <Button
                    style={{ border: 'none' }}
                    onClick={() => this.onPressAction(link.id, link.label, link.hidden, actions.hide)}
                  >
                    <Glyphicon 
                      glyph={(link.hidden === 0 ? "eye-open" : "eye-close")}
                    />
                    
                  </Button>
                  <Button
                    style={{ border: 'none' }}
                    onClick={() => this.onPressAction(link.id, link.label, link.hidden, actions.delete)}
                  >
                    <Glyphicon glyph="trash" />
                  </Button>
                </td>
              </tr>
            ))
          }
        </tbody>
      </Table>
    );
  }
}

export default LinksRowTable;


// WEBPACK FOOTER //
// ./src/app/screens/links/linksList/linksRowTable.js